module.exports = __webpack_public_path__ + "static/duff-phelps--dark-a3588f2cf53d8f29093e7e62b44d2179.png";